<template>
  <el-container class="page">
    <div class="header">
      <div class="text"><span>标准数据库 / </span><span>西药药品</span></div>
      <div class="content">
        <div class="search">
          <el-input placeholder="请输入药品名称" style="width:20%" prefix-icon="el-icon-search" v-model="from.search"
            class="header-search" size="small" @change="search" clearable>
          </el-input>
          <div style="margin-left: 10px">药品类别：</div>
          <el-select size="small" v-model="from.firstCategroyId" slot="prepend" clearable placeholder="请选择一级类别"
            @focus="searchOneSelect" @change="changeSearchOneSelect">
            <el-option :label="item.categoryName" :value="item.id" v-for="(item, index) in searchOneList" :key="index">
            </el-option>
          </el-select>
          <div style="width:10px"></div>
          <el-select size="small" v-model="from.searchTwoSelectValue" value-key="id" slot="append"
            @focus="searchTwoSelect" @change="changeSearchTwoSelect" placeholder="请选择二级类别">
            <el-option :label="item.categoryName" :value="item" v-for="(item, index) in searchTwoList" :key="index">
            </el-option>
          </el-select>

          <el-button size="small" @click="resetSearch" style="margin-left:10px">重置</el-button>
          <el-button size="small" style="background: #1a7bfc; color: #fff" @click="search(1)">搜索</el-button>
        </div>
        <!-- <div>
          <el-button size="mini" @click="importExcel">导入Excel</el-button>
          <el-button size="mini" @click="exportExcel">导出Excel</el-button>
        </div> -->
        <div class="excel-crtol">
          <el-button size="small" @click="addDrugClass">新增西药类别</el-button>
          <el-button size="small" style="background: #1a7bfc; color: #fff" @click="addDrug">新增西药药品</el-button>
        </div>
      </div>
    </div>
    <el-main class="table">
      <div class="table-content">
        <BaseTable size="mini" border stripe :data="tableData" :column="drugTableListConfig" pagination
          :auto-scroll="true" :total="totalPage" :page.sync="listQuery.current" @selection-change="selectionChange"
          :limit.sync="listQuery.size" @pagination="getList">
        </BaseTable>
      </div>
    </el-main>

    <el-dialog :close-on-click-modal="false" title="新增药品分类" :visible.sync="dialogClassFormVisible">
      <el-form :model="classForm" size="small">
        <el-form-item label="分类名称：" :label-width="formLabelWidth">
          <el-input placeholder="请选择分类名称" v-model="classForm.categoryName" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="上级分类：" :label-width="formLabelWidth">
          <el-select v-model="classForm.selectName" placeholder="请选择上级分类" @focus="focusSelect" @change="changeSelect"
            style="width: 100%">
            <el-option :label="item.categoryName" :value="item" v-for="(item, index) in selectList" :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="是否启用：" :label-width="formLabelWidth">
          <el-radio-group v-model="classForm.status">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">
          <el-input type="textarea" rows="4" v-model="classForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDrugClass" size="small" style="width: 110px">重置</el-button>
        <el-button type="primary" @click="saveDrugClass" size="small"
          style="background: #1a7bfc; color: #fff; width: 110px">保存</el-button>
      </div>
    </el-dialog>
    <!-- 新增药品 -->
    <el-dialog class="" style="height: 100%" :title="drugTitle" :visible.sync="dialogVisible" :lock-scroll="false"
      :close-on-click-modal="false" @close="cancelClose">
      <div style="height: 500px;">
        <el-scrollbar ref="scrollbar" style="height: 100%" wrap-style="overflow-x:hidden;">
          <div class="drug-header">
            <div class="solid"></div>
            <div class="">基础信息</div>
          </div>
          <el-form :model="drugForm" :rules="rules" ref="drugForm" size="small">
            <el-form-item label="药品名称：" :label-width="formLabelWidth" prop="name">
              <el-input placeholder="请输入药品名称" v-model="drugForm.name" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="药品编码：" :label-width="formLabelWidth" prop="code">
              <el-input v-model="drugForm.code" @keyup.native="drugForm.code = drugForm.code.replace(/[^a-zA-Z0-9]/g, '')"
                placeholder="请输入字母和数字" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="通用名称：" :label-width="formLabelWidth" prop="currencyName">
              <el-input placeholder="请输入通用名称" v-model="drugForm.currencyName" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" :label-width="formLabelWidth">
              <el-input placeholder="请输入商品名称" v-model="drugForm.shopName" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="品牌名：" :label-width="formLabelWidth">
              <el-input placeholder="请输入品牌名" v-model="drugForm.brandName" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
            <el-form-item label="英文名称：" :label-width="formLabelWidth">
              <el-input v-model="drugForm.english" autocomplete="off"
                @keyup.native="drugForm.english = drugForm.english.replace(/[^a-zA-Z0-9]/g, '')" placeholder="请输入英文字母"
                clearable></el-input>
            </el-form-item>
            <el-form-item label="一级分类：" :label-width="formLabelWidth" prop="firstCategroyName">
              <el-select v-model="drugForm.firstCategroyName" placeholder="请选择一级分类" @focus="focusOneSelect"
                @change="changeOneSelect" style="width: 100%" class="scrollB" popper-class="select-popper">
                <el-option :label="item.categoryName" :value="item.id" v-for="(item, index) in selectOneList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="二级分类：" :label-width="formLabelWidth" prop="secondCategoryName">
              <el-select v-model="drugForm.secondCategoryName" placeholder="请选择二级分类" @change="changeTwoSelect"
                style="width: 100%" class="scrollB" popper-class="select-popper">
                <el-option :label="item.categoryName" :value="item.id" v-for="(item, index) in selectTwoList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="规格：" :label-width="formLabelWidth" prop="packageSpName">
              <el-input placeholder="请输入规格" v-model="drugForm.packageSpName">
                <el-select style="width: 100px" v-model="drugForm.packageUnitName" slot="append" placeholder="请选择">
                  <el-option :label="item.name" :value="item.name" v-for="(item, index) in packageUnitList"
                    :key="index"></el-option>
                </el-select>
              </el-input>
            </el-form-item>

            <el-form-item label="剂型：" :label-width="formLabelWidth" prop="dosageForm">
              <el-select v-model="drugForm.dosageForm" placeholder="请选择剂型" style="width: 100%" @focus="focusDosage"
                class="scrollB" popper-class="select-popper">
                <el-option :label="item.name" :value="item.name" v-for="(item, index) in selectDosageList" :key="index">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否处方药：" :label-width="formLabelWidth">
              <el-radio-group v-model="drugForm.prescription">
                <el-radio :label="'0'">是</el-radio>
                <el-radio :label="'1'">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用：" :label-width="formLabelWidth">
              <el-radio-group v-model="drugForm.isEnable">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="性状：" :label-width="formLabelWidth">
              <el-input placeholder="请输入性状" v-model="drugForm.character" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="适应症：" :label-width="formLabelWidth">
              <el-input placeholder="请输入适应症" v-model="drugForm.indication" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="用法用量：" :label-width="formLabelWidth">
              <el-input placeholder="请输入用法用量" v-model="drugForm.useDosageName" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="不良反应：" :label-width="formLabelWidth">
              <el-input placeholder="请输入不良反应" v-model="drugForm.adverseReactions" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="禁忌：" :label-width="formLabelWidth">
              <el-input placeholder="请输入禁忌" v-model="drugForm.contraindication" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="注意事项：" :label-width="formLabelWidth">
              <el-input placeholder="请输入注意事项" v-model="drugForm.carefulMatter" autocomplete="off" clearable></el-input>
            </el-form-item>

            <el-form-item label="孕妇及哺乳期妇女用药：" :label-width="formLabelWidth">
              <el-input placeholder="请输入孕妇及哺乳期妇女用药" v-model="drugForm.gravidaDrug" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="儿童用药：" :label-width="formLabelWidth">
              <el-input placeholder="请输入儿童用药" v-model="drugForm.childrenDrug" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="老人用药：" :label-width="formLabelWidth">
              <el-input placeholder="请输入老人用药" v-model="drugForm.oldPeopleDrug" autocomplete="off" clearable></el-input>
            </el-form-item>

            <el-form-item label="药物相互作用：" :label-width="formLabelWidth">
              <el-input placeholder="请输入药物相互作用" v-model="drugForm.mutualEffect" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="药物过量：" :label-width="formLabelWidth">
              <el-input placeholder="请输入药物过量" v-model="drugForm.drugOverdose" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="药物毒理：" :label-width="formLabelWidth">
              <el-input placeholder="请输入药物毒理" v-model="drugForm.drugToxicology" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="药代动力学：" :label-width="formLabelWidth">
              <el-input placeholder="请输入药代动力学" v-model="drugForm.pharmacokinetics" autocomplete="off" clearable></el-input>
            </el-form-item>

            <el-form-item label="有效期：" :label-width="formLabelWidth" prop="effectiveTime">
              <el-input placeholder="请输入有效期" v-model.number="drugForm.effectiveTime" class="input-with-select"
                type="number" @keydown.native="channelInputLimit">
                <el-select style="width: 100px" v-model="drugForm.effectiveTimeUnit" slot="append" placeholder="请选择"
                  class="scrollB" popper-class="select-popper">
                  <el-option :label="item.name" :value="item.name" v-for="(item, index) in dateSelect" :key="index">
                  </el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="贮藏：" :label-width="formLabelWidth">
              <el-input placeholder="请输入贮藏" v-model="drugForm.storeCondition" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="执行标准：" :label-width="formLabelWidth">
              <el-input placeholder="请输入执行标准" v-model="drugForm.executiveStandard" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="批准文号：" :label-width="formLabelWidth">
              <el-input placeholder="请输入批准文号" v-model="drugForm.approvalNumber" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="生产企业：" :label-width="formLabelWidth">
              <el-input placeholder="请输入生产企业" v-model="drugForm.venderName" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <el-input placeholder="请输入备注" v-model="drugForm.remark" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-form>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDrug" size="small" style="width: 110px">重置</el-button>
        <el-button type="primary" size="small" @click="saveDrug('drugForm')"
          style="width: 110px; background: #1a7bfc; color: #fff">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog class="" title="西药药品查看" :visible.sync="dialogVisibleDetails">
      <ShowText :listData="showTextList"></ShowText>
    </el-dialog>
  </el-container>
</template>

<script>
import drugTableListConfig from "../../common/tableConfig";
import Excel from "../../common/excel.js";
import ShowText from "@/views/StandardDatabase/components/showText";
import {
  getClassification,
  addCategory,
  addDrugInfo,
  getDosageOrUnit,
  getDrugList,
  updateEnable,
  deleteDrug,
  updateDrug
} from "../../api";
export default {
  mixins: [drugTableListConfig],
  data() {
    var validateCode = (rule, value, callback) => {
      // if (!value) {
      //   return callback(new Error('学科代码不能为空'))
      // }
      let regx = /^[a-z0-9]+$/i;
      if (regx.test(value)) {
        callback();
      } else {
        callback(new Error("请输入数字和英文"));
        this.ruleForm.categoryCode = "";
        return;
      }
    };
    return {
      from: {
        search: "",
        searchOneSelectValue: "",
        searchTwoSelectValue: "",
        firstCategroyId: "",
        secondCategoryId: ""
      },
      showTextList: {
        title: "基础信息",
        list: [
          {
            label: "name",
            name: "药品名称:",
            value: ""
          },
          {
            label: "code",
            name: "药品编码:",
            value: ""
          },
          {
            label: "currencyName",
            name: "通用名称:",
            value: ""
          },
          {
            label: "shopName",
            name: "商品名称:",
            value: ""
          },
          {
            label: "brandName",
            name: "品牌名称:",
            value: ""
          },
          {
            label: "english",
            name: "英文名称:",
            value: ""
          },

          {
            label: "firstCategroyName",
            name: "一级分类:",
            value: ""
          },
          {
            label: "secondCategoryName",
            name: "二级分类:",
            value: ""
          },
          {
            label: "packageSpName",
            name: "规格:",
            value: ""
          },
          // {
          //   label: 'packageUnitName',
          //   name: '',
          //   value: '',
          // },
          {
            label: "dosageForm",
            name: " 剂型:",
            value: ""
          },
          {
            label: "prescription",
            name: "是否处方药:",
            value: "1"
          },
          {
            label: "isEnable",
            name: "是否启用:",
            value: true
          },
          {
            label: "indication",
            name: "适应症:",
            value: ""
          },
          {
            label: "useDosageName",
            name: "用法用量:",
            value: ""
          },
          {
            label: "adverseReactions",
            name: "不良反应:",
            value: ""
          },
          {
            label: "contraindication",
            name: "禁忌:",
            value: ""
          },
          {
            label: "gravidaDrug",
            name: "孕期及哺乳期妇女用药:",
            value: ""
          },
          {
            label: "childrenDrug",
            name: "儿童用药:",
            value: ""
          },
          {
            label: "oldPeopleDrug",
            name: "老年用药:",
            value: ""
          },
          {
            label: "mutualEffect",
            name: "药物相互作用:",
            value: ""
          },
          {
            label: "drugOverdose",
            name: "药物过量:",
            value: ""
          },
          {
            label: "drugToxicology",
            name: "药物毒理:",
            value: ""
          },
          {
            label: "pharmacokinetics",
            name: "药代动力学:",
            value: ""
          },
          {
            label: "effectiveTime",
            name: "有效期:",
            value: ""
          },
          {
            label: "storeCondition",
            name: "贮藏:",
            value: ""
          },
          {
            label: "executiveStandard",
            name: "执行标准:",
            value: ""
          },
          {
            label: "approvalNumber",
            name: "批准文号:",
            value: ""
          },
          {
            label: "venderName",
            name: "生产企业:",
            value: ""
          },
          {
            label: "remark",
            name: "备注:",
            value: ""
          }
        ]
      },
      searchOneList: [],
      searchTwoList: [],
      tableData: [],
      totalPage: 0,
      listQuery: {
        current: 1,
        size: 10
      },
      dateSelect: [
        {
          name: "月"
        },
        {
          name: "日"
        },
        {
          name: "年"
        }
      ],
      jsonData: [
        {
          name: "路人甲",
          phone: "123456789",
          email: "000@123456.com"
        },
        {
          name: "炮灰乙",
          phone: "123456789",
          email: "000@123456.com"
        },
        {
          name: "土匪丙",
          phone: "123456789",
          email: "000@123456.com"
        },
        {
          name: "流氓丁",
          phone: "123456789",
          email: "000@123456.com"
        }
      ],
      dialogClassFormVisible: false, // 药品类别
      dialogVisible: false, // 药品
      dialogVisibleDetails: false, // 详情
      // 分类类别
      classForm: {
        categoryName: "",
        // status: false,
        remark: "",
        selectName: ""
      },
      drugForm: {
        name: "",
        code: "",
        currencyName: "", // 通用名称
        adverseReactions: "", // 不良反应
        approvalNumber: "", // 批准文号
        carefulMatter: "", // 注意事项
        gravidaDrug: "", // 妇女用药
        childrenDrug: "", // 儿童用药
        oldPeopleDrug: "", // 老人用药

        categoryAction: "", // 作用类别
        character: "", // 性状
        contraindication: "", // 禁忌
        dosageForm: "", // 剂型
        firstCategroyName: "", // 一级分类名称
        // functions:'',// 功能主治
        indication: "", // 适应症

        // kind:'',// 药品分类
        mutualEffect: "", // 相互作用
        drugOverdose: "", // 过量
        drugToxicology: "", // 药物毒理
        pharmacokinetics: "", // 药代动力

        // pcAction:'',//生产企业产地
        prescription: "1", //是否处方 0 是 1 否

        saled: "", // 商户上架下架
        secondCategoryName: "", // 二级分类
        shopName: "", // 商品名
        packageSpName: "", // 规格
        isEnable: true, //状态 0 是 1否
        storeCondition: "", //贮藏
        // supplierSaled:'',// 供应商药品上下架状态？
        useDosageName: "", // 用法用量
        validTime: "", // 有效期
        venderName: "", // 生产企业
        packageSpName: "", // 规格
        packageUnitName: "", // 规格单位

        effectiveTimeUnit: "月", // 有效时间单位
        effectiveTime: "", // 有效时间
        executiveStandard: "", // 执行标准
        english: "", // 英文
        remark: "" // 备注
      },
      //规格单位
      packageUnitList: [],
      selectDosageList: [],
      rules: {
        name: [
          { required: true, message: "药品名称不能为空", trigger: "blur" }
        ],
        code: [
          { required: true, message: "药品编码不能为空", trigger: "blur" }
          // { validator: validateCode, trigger: 'blur' },
        ],
        currencyName: [
          { required: true, message: "通用名不能为空", trigger: "blur" }
        ],
        firstCategroyName: [
          { required: true, message: "一级分类请选择", trigger: "blur" }
        ],
        secondCategoryName: [
          { required: true, message: "二级分类请选择", trigger: "blur" }
        ],
        packageSpName: [
          { required: true, message: "请选择规格", trigger: "blur" }
        ],
        dosageForm: [
          { required: true, message: "请选择剂型", trigger: "blur" }
        ],
        effectiveTime: [
          { required: true, message: "请输入有效期", trigger: "blur" }
        ]
      },
      formLabelWidth: "170px",
      selectList: [],
      selectOneList: [], // 一级分类
      selectTwoList: [], // 二级分类
      parentId: "",
      drugTitle: "",
      totalPage: 0,
      searchTwoId: "",
      showRow: true,
      twoId: ""
    };
  },
  components: {
    ShowText
  },
  created() {
    this.init();
  },
  methods: {
    getList() {
      this.init();
    },
    /**
     * 获取首页数据
     */
    init() {
      let query = {
        name: this.from.search,
        current: this.listQuery.current,
        size: this.listQuery.size,
        rwsData: true
      };
      if (this.from.firstCategroyId) {
        query.firstCategroyId = this.from.firstCategroyId;
      }
      if (this.from.secondCategoryId) {
        query.secondCategoryId = this.from.secondCategoryId;
      }
      getDrugList(query).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.totalPage = res.data.total;
        } else {
        }
      });
    },
    // 重置
    resetSearch() {
      this.from = {};
      this.searchTwoId = "";
      this.searchTwoList = [];
      this.searchOneList = [];
      this.search(1)
    },
    /**
     * 分页事件
     */

    /**
     * 搜索
     */
    search(flag) {
      if (flag === 1) {
        this.listQuery.current = 1
        this.listQuery.size = 10
      }
      this.init();
    },
    selectionChange() { },
    /**
     * 查看此条数据
     */
    showRowData(e) {
      this.showRow = false;
      // this.drugTitle  = '详情'
      // this.dialogVisible = true
      this.dialogVisibleDetails = true;
      // this.drugForm = e
      this.showTextList.list = this.showTextList.list.map(item => {
        item.value = e[item.label] || "";
        if (item.label == "isEnable") {
          item.value = e[item.label] ? "是" : "否";
        }
        if (item.label == "prescription") {
          item.value = e[item.label] == "0" ? "是" : "否";
        }

        if (item.label == "packageSpName") {
          item.value = e[item.label] + e.packageUnitName;
          // item.value = e[item.label] + unitName
        }
        if (item.label == "effectiveTime") {
          item.value = e[item.label] + e.effectiveTimeUnit;
        }

        return item;
      });
      // Object.keys(e).map(item=>{

      //   // this.showTextList.list.push({
      //   //   name:item,
      //   //   value: e[item]

      //   // })
      //   // this.showTextList.list[0].label = item
      //   this.showTextList.list[0].value = e[item]

      // })

      // this.showTextList.list.forEach(el=>{
      //   el.value = e
      // })
      //   arr.push(e)
      //  this.showTextList.list = arr
      //   arr.forEach(el=>{
      //     this.showTextList.list.push(el)
      //   })
    },
    /**
     * 添加医药
     */
    async addDrug() {
      // 获取默认单位
      await this.focusUnit();
      this.dialogVisible = !this.dialogVisible;
      this.drugTitle = "新增西药药品";
      this.drugForm = {
        isEnable: true,
        prescription: "1",
        effectiveTimeUnit: "月",
        packageUnitName: this.packageUnitList[0].name
      };

      // this.drugForm.isEnable = true
      // this.drugForm.prescription = '1'

      // this.drugForm.effectiveTimeUnit = '月'
      this.twoId = "";
      this.selectTwoList = [];

    },
    /**
     * 添加医药类别
     */
    addDrugClass() {
      this.dialogClassFormVisible = !this.dialogClassFormVisible;
    },
    changeSelect(e) {
      this.classForm.selectName = e.categoryName;
      this.parentId = e.id;
    },
    focusSelect() {
      let query = {
        parentId: 0,

        type: 1
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.selectList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 编辑此条数据
     */
    async editRowData(e) {
      // 获取默认单位
      await this.focusUnit();

      // this.$refs.drugForm.resetField()
      this.drugTitle = "西药药品编辑";
      this.dialogVisible = true;
      this.drugForm = JSON.parse(JSON.stringify(e));
      // if(!this.drugForm.packageUnitName) {
      //   this.drugForm.packageUnitName = this.packageUnitList[0].name
      // }
      if (!this.drugForm.effectiveTimeUnit) {
        this.drugForm.effectiveTimeUnit = '月'
      }

      this.twoId = "";
      this.selectTwoList = [];
    },
    /**
     * 停用此条数据
     */
    disableRowData(e) {
      updateEnable(e.id).then(res => {
        if (res.code == 0) {
          if (e.isEnable == 0) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("停用成功");
          }
          this.init();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 删除此条数据
     */
    deleteRowData(e) {

      this.$confirm("确定要删除此条数据吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        customClass: "message-confirm-style"
      })
        .then(() => {
          deleteDrug(e.id).then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.init();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(er => {

          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /**
     * 导入此条数据
     */
    // importExcel() {
    //   Excel.importExcel((data, dataRef) => {
    //     alert("数据已经打印在控制台");
    //   });
    // },
    /**
     * 导出此条数据
     */
    exportExcel() {
      Excel.exportExcel(this.jsonData, "文件");
    },
    /**
     * 重置药品
     */
    resetDrug() {
      this.$refs.drugForm.resetFields();

      this.drugForm = {
        prescription: "1",
        isEnable: true
      };
      this.twoId = "";
    },
    /**
     * 保存药品
     * */
    saveDrug(drugForm) {
      this.$refs[drugForm].validate(valid => {
        if (valid) {
          if (this.drugTitle == "西药药品编辑") {
            updateDrug(this.drugForm).then(res => {
              if (res.code == 0) {
                setTimeout(() => {
                  this.dialogVisible = false;
                }, 1000);
                this.drugForm = {
                  prescription: "1",
                  isEnable: true
                };
                this.init();
                this.$message.success("保存成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            addDrugInfo(this.drugForm).then(res => {
              if (res.code == 0) {
                setTimeout(() => {
                  this.dialogVisible = false;
                }, 1000);
                this.drugForm = {
                  prescription: "1",
                  isEnable: true
                };
                this.init();
                this.$message.success("保存成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 重置药品类别
     */
    resetDrugClass() {
      // this.dialogClassFormVisible = false
      this.classForm = {};
      this.parentId = "";
    },
    /**
     * 保存类别
     * */
    saveDrugClass() {
      let query = {
        categoryName: this.classForm.categoryName,
        parentId: this.parentId || 0,

        // status: this.classForm.status,
        type: 1
      };
      addCategory(query).then(res => {
        if (res.code == 0) {
          this.classForm = {};
          this.$message.success("保存成功");
          setTimeout(() => {
            this.dialogClassFormVisible = false;
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 获取剂型
     */
    focusDosage() {
      getDosageOrUnit("dosage_form").then(res => {
        if (res.code == 0) {
          this.selectDosageList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     * 获取规格单位
     */
    async focusUnit() {
      let res = await getDosageOrUnit("drug_specs")
      if (res.code == 0) {
        this.packageUnitList = res.data;
        // this.drugForm.packageUnitName = this.packageUnitList[0].name
        // this.$set(
        //   this.drugForm,
        //   "packageUnitName",
        //   this.packageUnitList[0].name
        // );
      } else {
        this.$message.error(res.message);
      }
    },
    changeOneSelect(e) {
      // this.$nextTick(()=>{
      //   const name = ''
      //   this.drugForm.secondCategoryName = name
      // })
      this.twoId = e;

      this.drugForm.firstCategroyId = e;
      this.selectOneList.forEach(el => {
        if (el.id == e) {
          this.drugForm.firstCategroyName = el.categoryName;
        }
      });

      this.focusTwoSelect();
    },
    changeTwoSelect(e) {
      this.drugForm.secondCategoryId = e;

      // this.drugForm={
      //   secondCategoryId: name.id,
      //   secondCategoryName: name.categoryName
      // }
      // this.drugForm.secondCategoryName = e.ts;
      this.selectTwoList.forEach(el => {
        if (el.id == e) {
          this.drugForm.secondCategoryName = el.categoryName;
        }
      });
    },
    focusOneSelect() {
      // 修复选中不了
      // this.$set(this.drugForm, "secondCategoryName", "");
      let query = {
        parentId: 0,
        type: 1
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.selectOneList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    focusTwoSelect() {
      if (!this.twoId) {
        this.$message("请重新选择上一级");
        return;
      }
      let query = {
        parentId: this.twoId,
        type: 1
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.selectTwoList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 查询一级
    searchOneSelect() {
      let query = {
        parentId: 0,
        type: 1
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.searchOneList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeSearchOneSelect(e) {
      if (e) {
        this.from.searchOneSelectValue = this.searchOneList.filter(
          v => v.id === e
        )[0].categoryName;
      }
      // this.from.searchOneSelectValue = e.categoryName
      this.searchTwoId = e;
      // this.from.firstCategroyId = e.id

      this.from.searchTwoSelectValue = "";
    },
    changeSearchTwoSelect(e) {
      this.from.secondCategoryId = e.id;
      // this.from.searchTwoSelectValue = e.categoryName;
    },

    searchTwoSelect() {
      if (!this.searchTwoId) {
        this.$message("请选择一级类别");
        return;
      }
      let query = {
        parentId: this.searchTwoId,
        type: 1
      };
      getClassification(query).then(res => {
        if (res.code == 0) {
          this.searchTwoList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // changeTime(e){
    //   this.drugForm.effectiveTimeUnit = e
    // },
    cancelClose() {
      // alert('kkkk')
      this.$refs.drugForm.resetFields();
    },
    // handleScroll(){
    //   // let scrollbarEl =this.$refs['elscrollbar']
    //   let scrollbarEl = this.$refs.scrollbar.wrap

    //   scrollbarEl.onscroll = () => {

    //   }
    // }

    // 禁止输入幂 e
    channelInputLimit(e) {
      let key = e.key;
      // 不允许输入'e'和'.'
      if (key === "e" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    }
  }
  // mounted() {
  //   this.handleScroll()
  // },
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;

  .header {
    padding: 20px;
    width: 100%;
    background: #fff;

    .text {
      margin-bottom: 20px;
      color: #333333;
      font-size: 14px;

      span:nth-child(2) {
        color: #000000;
      }

      span:nth-child(1) {
        color: #666666;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;

      .search {
        display: flex;
        align-items: center;
        flex: 1;
      }
    }
  }
}

.header {
  background: #fff;
  padding: 24px;
  // .header-left{
  //   display: flex;
  //   align-items: center;

  // }
  // .header-search {
  //   width: 330px;
  // }
}

.table {
  padding: 20px;

  .table-content {
    padding: 20px;
    background: #fff;
  }
}

.pagination-container {
  margin-top: 16px;
  text-align: right;
}

.drug-header {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: 20px;

  .solid {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    // border-radius: 2px;
    margin-right: 5px;
  }
}

.dialog-footer {
  text-align: center;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.scrollB {
  position: relative !important;
}

.scrollB /deep/ .select-popper {
  position: absolute !important;
  top: auto !important;
  left: auto !important;
}

/deep/ .el-select-dropdown .el-popper {
  position: absolute !important;
  top: -20px;
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}

/deep/.el-table th>.cell {
  color: #333;
  font-weight: bold;
}

/deep/.el-table--border td,
.el-table--border th {
  border: none;
}

/deep/.el-table--border,
.el-table--group {
  border: none;
}

/deep/.el-table th {
  background: #fafafa;
}

/deep/.el-table--mini td,
.el-table--mini th {
  padding: 15px 0 !important;
}
</style>
